export const route = {
    path: '/main',
    name: 'main',
    redirect: '/home',
    meta: { title: 'Menu.ManageMenu', hideInMenu: true,notCache: true },
    component: ()=> import('./index.vue'),
    children: [
        { path: 'home', meta: { title: 'Menu.HomePage', hideInMenu: true }, name: 'home', component: () => import('./home/index.vue') }
    ]
}

  export default route
